// Auto-generated from about.html
// Do not edit this file directly - edit about.html in public/pages/ instead

export const aboutContent = `<div class="page-section-wrapper">
  <!-- Schema.org Person Structured Data for SEO -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Khoa Tran",
    "alternateName": "DYAR",
    "url": "https://dyararts.com",
    "image": "https://dyararts.com/images/khoa_tran_dyar.jpg",
    "jobTitle": "Artist and Designer",
    "description": "Artist and designer with over 24 years of experience solving visual problems. Creating original artwork by applying design thinking to traditional art forms.",
    "slogan": "Design Your Art",
    "sameAs": [
      "https://youtube.com/@dyararts",
      "https://www.instagram.com/dyararts",
      "https://www.tiktok.com/@dyararts"
    ],
    "knowsAbout": ["Art", "Design", "Visual Arts", "Drawing", "Painting", "Visual Storytelling"]
  }
  </script>
  
  <div class="page-section-header">
    <a href="/" class="btn-home">←</a>
    <h1>About<span> DYAR</span></h1>
  </div>
  <div class="profile-image" role="img" aria-label="Khoa Tran DYAR">
    <img 
      src="https://dyararts.com/images/khoa_tran_dyar.jpg" 
      alt="Khoa Tran (DYAR) - Artist and Designer portrait photo"
      class="profile-image-seo"
    />
  </div>
<p>My name is Khoa Tran, aka DYAR ("dire").</p>
<p>I've been drawing since I was a kid but I already knew that being just an  artist was not a viable career choice, so I went to art college. The family wasn't thrilled that I brought home drawings of naked old dudes, so I switched to "digital media." It wasn't officially graphic design yet, but we got to use Photoshop.</p>
<p>Ironically, I spent 24-plus years in the tech industry to pay off that education.</p>
<p>My background in UX/UI design and marketing taught me how to translate complex ideas into simple messages. I apply that same discipline to my art.</p>
<p>DYAR Arts is my creative studio where I make story-driven art and help other artists think more like designers.</p>
  
  <div class="social-section">
    <div class="social-text">See my work in action</div>
    <div class="social-buttons">
      <a
        href="https://youtube.com/@dyararts"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
        aria-label="View on YouTube"
      >
        <img
          src="https://dyararts.com/images/social_youtube_icon.png"
          alt="YouTube icon"
          class="social-icon"
        />
        <div class="social-link-text">
          <span>YouTube</span>
          @dyararts
        </div>
      </a>
      <!--a
        href="https://www.instagram.com/dyararts"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
        aria-label="View on Instagram"
      >
        <img
          src="https://dyararts.com/images/social_instagram_icon.png"
          alt="Instagram icon"
          class="social-icon"
        />
        <div class="social-link-text">
          <span>Instagram</span>
          @dyararts
        </div>
      </a>
      <a
        href="https://www.tiktok.com/@dyararts"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
        aria-label="View on TikTok"
      >
        <img
          src="https://dyararts.com/images/social_tiktok_icon.png"
          alt="TikTok icon"
          class="social-icon"
        />
        <div class="social-link-text">
          <span>TikTok</span>
          @dyararts
        </div>
      </a-->
    </div>
  </div>
</div>



<div id="contact"></div>
<div class="page-section-wrapper">
  <div class="page-section-header">
    <a href="/" class="btn-home">←</a>
    <h1>Contact</h1>
  </div>
  <p>How can I help you?</p>
  
  <form class="contact-form" id="contact-form">
    <div class="form-group">
      <label for="name">Name</label>
      <input type="text" id="name" name="name" required>
    </div>
    
    <div class="form-group">
      <label for="email">Email</label>
      <input type="email" id="email" name="email" required>
    </div>
    
    <div class="form-group">
      <label for="subject">Subject</label>
      <input type="text" id="subject" name="subject" required>
    </div>
    
    <div class="form-group">
      <label for="message">Message</label>
      <textarea id="message" name="message" rows="6" required></textarea>
    </div>
    
    <div class="form-status" id="form-status"></div>
    
    <button type="submit" class="btn" id="submit-btn">Send Message</button>
  </form>
</div>

<script>
  document.getElementById('contact-form').addEventListener('submit', function(e) {
    e.preventDefault();
    
    const form = this;
    const submitBtn = document.getElementById('submit-btn');
    const formStatus = document.getElementById('form-status');
    const formData = new FormData(form);
    
    // Disable button and show loading
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';
    formStatus.textContent = '';
    formStatus.className = 'form-status';
    
    // Send form data
    fetch('/contact-handler.php', {
      method: 'POST',
      body: formData
    })
    .then(response => response.text().then(text => ({
      ok: response.ok,
      text: text
    })))
    .then(result => {
      if (result.ok) {
        formStatus.textContent = '✓ ' + result.text;
        formStatus.className = 'form-status success';
        form.reset();
      } else {
        formStatus.textContent = '✗ ' + result.text;
        formStatus.className = 'form-status error';
      }
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Message';
    })
    .catch(error => {
      formStatus.textContent = '✗ Failed to send message. Please try again.';
      formStatus.className = 'form-status error';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Message';
    });
  });
</script>
`;
